export default __webpack_public_path__ + "static/fall4-0bb5cd36c9214385bcaf284660ee7b1b.webp";